/**
 * Admin Portal Time Manipulation Hooks
 *
 * This file instantiates the time manipulation hooks from the shared library
 * with the admin portal's time API client.
 */
import { createTimeManipulationHooks } from '@billda/shared-ui';
import { timeApi } from '../api/timeApi';

// Create hooks with the admin portal's time API
const timeHooks = createTimeManipulationHooks(timeApi);

// Export individual hooks for convenience
export const useGetCurrentTime = timeHooks.useGetCurrentTime;
export const useSetTime = timeHooks.useSetTime;
export const useAdvanceTime = timeHooks.useAdvanceTime;
export const useResetTime = timeHooks.useResetTime;
